import ParagraphEmailRenderer from "./email";

export default function ParagraphWeb(
  props: React.ComponentProps<typeof ParagraphEmailRenderer>,
) {
  return <ParagraphEmailRenderer {...props} />;
}
